import { X } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";

interface QuotePreviewProps {
  quote: string;
  onCancel?: () => void;
  className?: string;
}

/**
 * 引用预览面板组件
 * 显示在输入框上方，展示被引用的消息内容
 */
export function QuotePreview({
  quote,
  onCancel,
  className,
}: QuotePreviewProps) {
  return (
    <div
      className={cn(
        "flex items-start gap-3 px-4 py-3 border-l-4 border-blue-500 rounded-t-[21px]",
        className
      )}
    >
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-xs">回退到此对话</span>
        </div>
        <div className="text-xs text-gray-400 prose prose-neutral prose-p:my-0 prose-li:my-0 max-w-none">
          <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]}>
            {quote}
          </ReactMarkdown>
        </div>
      </div>

      {onCancel && (
        <Button
          variant="ghost"
          size="icon"
          onClick={onCancel}
          className="h-6 w-6 text-gray-400 hover:text-gray-900 hover:bg-blue-100 shrink-0"
          aria-label="取消回退"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
